import O1HD from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../modes/normalMode/BundleResourceConfig";
import NormalGameManager from "../../../modes/normalMode/manager/NormalGameManager";
import { getpawnShopObjMap, pawnShopObjPigmentCountAry, pawnShopObjQualityColorStrAry, pawnShopObjQualityExplainAry } from "./config/pawnShopConfig";
import { pawnShopBackpackObjI, pawnShopGameObjI } from "./const/pawnShopConst";
import pawnShopGame from "./pawnShopGame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopGameObtain extends cc.Component {

    @property({type:cc.RichText,displayName:"名字文本"})
    lb_name:cc.RichText = null;

    @property({type:cc.Sprite,displayName:"展示的图片节点"})
    showSp:cc.Sprite = null;

    @property({type:cc.Label,displayName:"购入价格文本"})
    lb_buyPrice:cc.Label = null;

    @property({type:cc.Label,displayName:"预估价格文本"})
    lb_Estimate:cc.Label = null;

    @property({type:cc.Label,displayName:"分解颜料文本"})
    lb_Pigment:cc.Label = null;

    @property({type:cc.Node,displayName:"光效节点"})
    lightNode:cc.Node = null;

    backpackObj:pawnShopBackpackObjI = null;

    gameScript:pawnShopGame = null;

    onLoad(){
        let tween = cc.tween(this.lightNode).to(4,{angle:360}).call(()=>{
            this.lightNode.angle = 0;
        });
        cc.tween(this.lightNode).repeatForever(tween).start();
    }

    onClickBg(){

    }

    bindData(obj:pawnShopBackpackObjI,game:pawnShopGame){
        this.gameScript = game;
        this.backpackObj = obj;
        this.updateDialog();
    }
    
    updateDialog(){
        let obj = getpawnShopObjMap()[this.backpackObj.id];
        let name = obj.name;
        this.lb_name.string = `<color = #FFFFFF>${name}(</c><color = #${pawnShopObjQualityColorStrAry[obj.quality]}>${pawnShopObjQualityExplainAry[obj.quality]}</c><color = #FFFFFF>)</c>`;
        this.lb_buyPrice.string = data_control.getNumberFormat(this.backpackObj.buyPrice);
        this.lb_Estimate.string = data_control.getNumberFormat(obj.price);
        this.loadSp();
        let objConfig = getpawnShopObjMap()[obj.id];
        let resolveCount:number = pawnShopObjPigmentCountAry[objConfig.quality];
        this.lb_Pigment.string = `×${resolveCount}`;
    }

    loadSp(){
        let obj = getpawnShopObjMap()[this.backpackObj.id];
        let name = obj.name;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.pawnShopGameBundle).load(`assets/pawnShopGame/obj/${name}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.log("# pawnShopGameObtain.ts 66");
                return;
            }
            this.showSp.spriteFrame = spr;
        });
    }

    closeThis(){
        this.gameScript.startApproach();
        this.node.destroy();
        this.node.removeFromParent();
    }

    //放入背包
    onBtnPushBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis();
    }

    //分解
    onBtnPigment(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        NormalGameManager._instance.pawnShopManager.resolveOneObj(this.backpackObj,true);
        this.closeThis();
    }

}
